import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function Pin({
  fillPrimary = colors.neutral100,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[16px] w-[16px]', className)}
    >
      <path
        d="M8.63677 13.7933L8.63627 13.7937C8.42922 13.9401 8.21699 14.079 7.99996 14.2102C7.78266 14.079 7.57015 13.94 7.36284 13.7935L7.36269 13.7934C6.75925 13.3672 6.19544 12.8875 5.67807 12.3601C4.45179 11.104 3.25 9.28838 3.25 7C3.25 5.74022 3.75044 4.53204 4.64124 3.64124C5.53204 2.75044 6.74022 2.25 8 2.25C9.25978 2.25 10.468 2.75044 11.3588 3.64124C12.2496 4.53204 12.75 5.74022 12.75 7C12.75 9.28911 11.5488 11.1041 10.3221 12.36C9.80449 12.8874 9.24044 13.3671 8.63677 13.7933Z"
        stroke={fillPrimary}
        strokeWidth="1.5"
      />
      <circle cx="8" cy="7" r="2" fill={fillPrimary} />
    </svg>
  );
}
